import * as yup from 'yup';
import type { FormDefinition } from '@gov-design-system-ce/react-form-core';
import {
	getFormDefinition,
	useGovForm,
} from '@gov-design-system-ce/react-form-core';
import type { SignpostRequestParams } from '@gov-nx/api';
import type { Optional } from '@gov-nx/core/types';
import type { SignpostFilterForm, SignpostListFilter } from './context.types';
import { sanitizeSearch } from './utils';

export function FormInstance(): FormDefinition<SignpostFilterForm> {
	const formSchema = yup
		.object({
			search: yup.string().nullable(),
		})
		.required();

	const formMethods = useGovForm<SignpostFilterForm>({
		formSchema,
		defaultValues: {
			search: null,
		},
	});

	return getFormDefinition({ formMethods, formSchema });
}

export const prepareSubmitData = (
	filter: SignpostListFilter,
	search: Optional<string>,
	app: string,
	env: string,
	designations?: SignpostRequestParams['designations']
): SignpostRequestParams => {
	const sanitized = search ? sanitizeSearch(search) : '';
	return {
		search: sanitized.length > 2 ? sanitized : undefined,
		serviceGroups: filter.serviceGroups ? filter.serviceGroups : undefined,
		app,
		env,
		locale: filter.language,
		designations,
	};
};
